module.exports = __webpack_public_path__ + "static/media/Bb1.d92b351f.mp3";